import React, { useEffect } from "react";
import Menu from "../Menu";
import Header from "../Header";
import Footer from "../Footer";
import { Table, Space } from "antd";
import Spinner from "../../helpers/shared/Spinner";
import MessageBox from "../../UIComponents/MessageBox/MessageBox";
import { useDispatch, useSelector } from "react-redux";
import {
  doGetAssetsCategoryList,
  subCatgeoryForEdit,
  mainCatgeoryForEdit,
} from "./actions/assetsCategoryService";
import AssetCategoryDrawer from "./AssetCategoryDrawer";
import AssetSubcatgeoryDrawer from "./AssetSubcatgeoryDrawer";
import { assetCategoryTitle } from "../../constants/Constants";

export default function AssetCategoryList() {

  const columns = [
    {
      title: "Edit Main Category",
      dataIndex: "editMainCatgeory",
      key: "editMainCatgeory",
      width: 150,
      render: (text, record) => (
        <Space size="middle">
          <div className="table-icons">
            <i
              className="fa fa-pencil blue"
              onClick={() => handleMainEditCategory(record)}
              aria-hidden="true"
            ></i>
          </div>
        </Space>
      ),
    },
    {
      title: "Asset Main Category Name",
      dataIndex: "main_category_name",
      key: "AssetCategoryName",
    },
    {
      title: "Edit Sub-Category",
      dataIndex: "editSubCategory",
      key: "editSubCategory",
      width: 150,
      render: (text, record) => (
        <Space size="middle">
          <div className="table-icons">
            <i
              className="fa fa-pencil blue"
              onClick={() => handleEditSubCategory(record)}
              aria-hidden="true"
            ></i>
          </div>
        </Space>
      ),
    },
    {
      title: "Asset Sub Category Name",
      dataIndex: "sub_category_name",
      key: "AssetSubCategoryName",
    },
  ];

  const dispatch = useDispatch();
  const { assetsCategoryList, status } = useSelector((state) => ({
    assetsCategoryList: state?.assetsCategoryList?.AssetsCategoryDetail,
    status: state?.assetsCategoryList,
  }));

  useEffect(() => {
    dispatch(doGetAssetsCategoryList());
  }, [dispatch]);

  const handleMainEditCategory = (item) => {
    dispatch(mainCatgeoryForEdit({ isEdit: true, data: item }));
  };

  const handleEditSubCategory = (item) => {
    dispatch(subCatgeoryForEdit({ isEdit: true, data: item }));
  };

  return (
    <>
      {status?.isSubCatList ? (
        <div>
          {status?.modalOpen && status?.message != undefined && (
            <MessageBox
              message={status?.message}
              onClose={() => {
                if (status?.apiStatus) {
                  dispatch(doGetAssetsCategoryList());
                }
              }}
            />
          )}

          <div className="wrapper">
            <Header title={assetCategoryTitle} />
            <Menu />
            <div className="content-wrapper">
              <Spinner isLoading={status?.loading}>
                <div>
                  <div className="m-btn-block">
                    <div className="m-btn-block__container">
                      <div className="m-btn-block__icon">
                        <i className="fa fa-plus-circle" aria-hidden="true"></i>
                      </div>
                      <div className="m-btn-block__btns">
                        <AssetCategoryDrawer />
                        <AssetSubcatgeoryDrawer />
                      </div>
                    </div>
                  </div>
                  <section className="content">
                    <div className="m-panel mt-10">
                      <div className="m-panel__body p10">
                        <div className="m-table__main">
                          <Table
                            columns={columns}
                            dataSource={
                              assetsCategoryList?.AllAssetCategoryList
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </Spinner>
            </div>
            <Footer />
          </div>
        </div>
      ) : null}
    </>
  );
}
